import React from "react";
import { IControlStyles, useControlStyles } from "../.";
import { ControlButtonGlobalStyle } from "./controlButton.styled";

export interface ControlButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    controlStyles?: IControlStyles | undefined;
}

const ComponentProps = (props: ControlButtonProps): React.ButtonHTMLAttributes<HTMLButtonElement> => {
    const componentProps = Object.assign({}, props);
    delete componentProps.controlStyles;

    return componentProps;
}

export const ControlButton: React.FC<ControlButtonProps> = (props) => {
    const styles: IControlStyles = props.controlStyles ?? useControlStyles();

    return (
        <>
            <ControlButtonGlobalStyle />
            <button {...ComponentProps(props)} style={{ ...styles.button, ...props.style }} />
        </>
    );
};